if (!customElements.get('academy-gift-card')) {
  class AcademyGiftCard extends HTMLElement {
    connectedCallback() {
      this.choiceSelector = '[data-gift-card-choice]';
      this.variantInput = this.querySelector('[data-gift-card-variant-id]');
      this.previewValues = this.querySelectorAll('[data-gift-card-preview-value], [data-gift-card-mini-value], [data-gift-card-summary-value]');
      this.summaryPrice = this.querySelector('[data-gift-card-summary-price]');
      this.submit = this.querySelector('[data-gift-card-submit]');
      this.submitLabel = this.querySelector('[data-gift-card-submit-label]');
      this.addEventListener('change', this.onChange.bind(this));
      const initial = this.querySelector(`${this.choiceSelector}:checked`);
      if (initial) this.update(initial);
    }

    onChange(event) {
      if (!event.target.matches(this.choiceSelector)) return;
      this.update(event.target);
    }

    update(choice) {
      const title = choice.dataset.title || '';
      const price = choice.dataset.price || '';
      const available = choice.dataset.available === 'true';

      if (this.variantInput) this.variantInput.value = choice.value;
      this.previewValues.forEach((element) => { element.textContent = title; });
      if (this.summaryPrice) this.summaryPrice.textContent = `${price} · pagamento unico`;
      if (this.submitLabel) this.submitLabel.textContent = available ? `Regala ${title}` : 'Taglio in verifica';
      if (this.submit) this.submit.disabled = !available;
    }
  }

  customElements.define('academy-gift-card', AcademyGiftCard);
}
